export const propertyObj = {
    "multi-choice": ["quantity", "count", "logic_state", "value"],
    "submodel": ["logic_state", "count"],
    "decimal": ["logic_state", "value"],
    "fraction": ["logic_state", "value"],
    "integer": ["logic_state", "value"],
    "boolean": ["logic_state", "value"],
    "choice": ["logic_state", "value", "quantity"],
    "product": ["logic_state", "value", "quantity"],
    "category": ["quantity", "count", "logic_state"],
    "text": ["logic_state", "value"],
    "range": ["logic_state", "value"],
}


export const LOGICAL = ["AND", "OR"]

export const OPERATORS = ["==","!=", ">", "<", ">=", "<="]

export const CONSTRAINTS = ['Includes', 'Excludes', 'Requires', 'Negates', 'Defaults']

export const BOOLEAN_LIST = [0, 1]

export const LOGICAL_OPERATORS_SOURCE = ["all_true", "all_false", "any_true"]
export const LOGICAL_OPERATORS_TARGET = ["all_true", "all_false"]

export const FIELD_TYPES = [ 
"multi-choice",
"decimal",
"fraction",
"integer",
"boolean",
"text",
"range"
]

export const NODE_TYPES = [
"submodel",
"category",
"choice",
"product",
]
